'use strict';

var $ = require('jquery');
var EgressIntent = require('egress-intent').default;
var magnific = require('magnific-popup');

var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function init() {
	var modalSrc = document.getElementById('ouibounceModal');
	if (!modalSrc) {
		return;
	}

	var modal = new EgressIntent({
		delay: 200,
		directions: 'top',
		aggressive: true,
		callback: function() {
			$.magnificPopup.open({
				items: {
					src: '#ouibounceModal',
					type: 'inline'
				},
				callbacks: {
					open: function() {
						console.log("'Newsletter Signup', 'Open', 'ExitIntent'");
						// analytics.trackEvent('Newsletter Signup', 'Open', 'ExitIntent', undefined, false);
					},
					close: function() {
						console.log("'Newsletter Signup', 'Close', 'ExitIntent'");
						// analytics.trackEvent('Newsletter Signup', 'Close', 'ExitIntent', undefined, false);
					}
				}
			});
		}
	});

	$(document).on('a4jComplete', function (event) {
		console.log('a4jComplete');
		if (modal) {
			modal.disable({ cookieExpire: 1 });
		}
	});
}

module.exports = {
	init: init
}
